import React, { useCallback, useContext, useState } from "react";
import { Link } from "react-router-dom";
import CarContext from "../../context/CarContext";

const UspDetails = () => {
    const { car } = useContext(CarContext);

    // Car has not Usp
    if ( ! car.usp || car.usp.length === 0 ) { 
        return (<></>); 
    }

    return (
        <div className='section usp'>
            <h2 className="section-title">Den här bilen passar dig som letar efter</h2>
            <ul className='is-style-checkmarks-medium usp-wrapper'>
                {
                    car.usp.map((usp, index) => {
                        return <UspAccordion key={usp.id} id={usp.id} title={usp.title} description={usp.description} index={index} />
                    })
                }
            </ul>
        </div>
    )
}

const UspAccordion = ({ id, title, description, index}) => {

    // Handle toggle, first item is open on init
    const [ open, setOpen ] = useState( index > 0 ? false : true);
    const toggle = useCallback((e)=>{
        setOpen( !open );
    },[setOpen, open])

    return (
        <li className="usp-item active" key={id}>
            <h3 
                aria-expanded={open}
                aria-controls={`usp-${id}`}
                id={`usp-title-${id}`}
                className="title"
                onClick={toggle}
            >{ title } <small>{ open ? 'Visa mindre':'Visa mer' }</small></h3>
            { open && 
                <div 
                    id={`usp-${id}`} 
                    className={`description${open ? ' active':''}`}
                    role="region"
                    aria-labelledby={`usp-title-${id}`}
                >
                    <p>
                        { description }
                        <br />
                        <Link to={`/?usp=${id}`}>Visa liknande bilar</Link>
                    </p>
                </div>
            }
        </li>
    )
}


export default UspDetails